<!--
 * @Author: your name
 * @Date: 2020-06-10 13:48:07
 * @LastEditTime: 2020-06-16 14:48:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \1-trunk\src\views\login\forget-pwd.vue
-->
<template>
  <div id="forgetPwd">
    <van-nav-bar title="联系管理员" left-arrow>
      <template #left>
        <div @click="back"><i class="iconfont iconbtn_24_back"></i></div>
      </template>
    </van-nav-bar>

    <div class="msg">
      <span>!</span>
      <span class="titleMsg">请联系相应系统管理员咨询账号密码</span>
    </div>
    <ul class="managerList">
      <li v-for="(item, index) in tableList" :key="index">
        <div class="headImg">
          <img src="../../assets/img_50_default_profile@2x.png" alt="" />
        </div>
        <div class="userInfo">
          <div class="userName">{{item.trueName}}</div>
          <div class="userPhone">{{item.mobileNumber}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'forgetPwd',
  data () {
    return {
      tableList: []
    };
  },
  created () {
    this.getusersList()
  },
  methods: {
    getusersList () {
      var hosts = document.domain
      this.$axios
        .post('/user/forget/password', {
          data: { hosts: hosts },
          version: this.$version
        })
        .then((res) => {
          this.tableList = res.data.list;
        });
    },
    back () {
      this.$router.go(-1);
    }
  },
  watch: {},
  computed: {},
  components: {}
};
</script>
<style lang="scss" scoped>
#forgetPwd {
  position: relative;
  z-index: 100;
  background-color: rgb(247, 247, 247);
  min-height: calc(100vh);
}
.msg {
  background: #e8effa;
  width: 100%;
  height: 40px;
  line-height: 40px;
  span {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #323233;
    letter-spacing: 0;
    line-height: 18px;
    padding-left: 16px;
  }
  .titleMsg {
    padding-left: 9px;
  }
}
.managerList {
  width: 100%;
  list-style: none;
  padding-bottom: 10px;
  li {
    width: 93.3%;
    margin: 10px auto;
    height: 78px;
    background: $white;
    box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    .headImg {
      float: left;
      margin-left: 4.3%;
      margin-top: 14px;
      img {
        height: 50px;
      }
    }
    .userInfo {
      float: left;
      margin-left: 4.3%;
      .userName {
        height: 22px;
        line-height: 22px;
        margin-top: 16px;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: $black;
        letter-spacing: 0;
        text-align: justify;
      }
      .userPhone {
        height: 20px;
        line-height: 20px;
        margin-top: 4px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: $black;
        letter-spacing: 0;
      }
    }
  }
}
</style>
